var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gwnl-step-footer", style: { width: _vm.footerWidth } },
    [
      _c(
        "div",
        { staticClass: "text-right mt12 mr32" },
        [
          _vm._t("right"),
          _vm.operation.cancel
            ? _c(
                "yxt-button",
                {
                  attrs: {
                    plain: "",
                    disabled: _vm.operation.cancelDisabled,
                    loading: _vm.operation.cancelLoading,
                  },
                  on: { click: _vm.operation.cancel },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.operation.cancelName ||
                          _vm.$t("pc_gwnl_global_msg_cancel" /* 取消 */)
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm.operation.save
            ? _c(
                "yxt-button",
                {
                  attrs: {
                    plain: !_vm.operation.disabled,
                    loading: _vm.operation.disabled,
                  },
                  on: { click: _vm.operation.save },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.operation.saveName ||
                          _vm.$t("pc_gwnl_global_btn_save" /* 保存 */)
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm.operation.preview
            ? _c(
                "yxt-button",
                {
                  attrs: {
                    plain: !_vm.operation.previewDisabled,
                    loading: _vm.operation.previewDisabled,
                  },
                  on: { click: _vm.operation.preview },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("pc_gwnl_global_btn_preview" /* 预览 */)) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm.operation.withdraw
            ? _c(
                "yxt-button",
                {
                  attrs: {
                    plain: !_vm.operation.withdrawDisabled,
                    loading: _vm.operation.withdrawDisabled,
                  },
                  on: { click: _vm.operation.withdraw },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("pc_gwnl_global_btn_recall" /* 撤回 */)) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm.operation.prev
            ? _c(
                "yxt-button",
                {
                  attrs: {
                    plain: !_vm.operation.prevDisabled,
                    loading: _vm.operation.prevDisabled,
                  },
                  on: { click: _vm.operation.prev },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("pc_gwnl_global_btn_previous" /* 上一步 */)
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm.operation.primaryPrev
            ? _c(
                "yxt-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.operation.primaryPrevDisabled,
                  },
                  on: { click: _vm.operation.primaryPrev },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("pc_gwnl_global_btn_previous" /* 上一步 */)
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm.operation.next
            ? _c(
                "yxt-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.operation.nextDisabled,
                  },
                  on: { click: _vm.operation.next },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("pc_gwnl_global_btn_next" /* 下一步 */)) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm.operation.publish
            ? _c(
                "yxt-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.operation.publishDisabled,
                  },
                  on: { click: _vm.operation.publish },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.operation.publishName ||
                          _vm.$t("pc_gwnl_global_btn_release" /* 发布 */)
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm.operation.primarySave
            ? _c(
                "yxt-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.operation.primarySaveDisabled,
                  },
                  on: { click: _vm.operation.primarySave },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.operation.saveText ||
                          _vm.$t("pc_gwnl_global_btn_save" /* 保存 */)
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }